

const errorMessages = {
  METHOD_NOT_IMPLEMENTED: '"@method" not implemented',
  KEY_DOES_NOT_HAVE_A_VALUE: 'Key value is not set',
  INSERT_ALREAD_INSERTED: 'Cannot insert item which is already inserted',
} as const

const msgGen = {
  METHOD_NOT_IMPLEMENTED: (methodName: string) => errorMessages.METHOD_NOT_IMPLEMENTED.replace(/@method/g, methodName)
}


export { errorMessages, msgGen };
